import moment from 'moment';
import SettingsUtils from '../utils/SettingsUtils'
import EntityUtils from '../utils/EntityUtils'
import CommunicationUtils from '../utils/CommunicationUtils'
import axios from 'axios'
import cloneDeep from 'lodash/cloneDeep'
import { template, intersection } from 'lodash';
import { firestore, firebaseApp } from '../firebaseConfig'
import * as routes from '../constants/routes';
import React from 'react';
import { Dropdown, Checkbox, List, Label, Icon, Popup } from 'semantic-ui-react'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { de } from 'date-fns/locale';
import NotificationUtils from '../utils/NotificationUtils'
import BillingUtils from '../utils/BillingUtils'
import { DateTime, Settings } from "luxon";
import SelectableText from '../components/SelectableText'
import merge from 'lodash/merge'

class CommonFunctionsUtils {

    validateEmail(email){
        let valid = false
        if(email !== undefined && (typeof email === 'string' || email instanceof String)){
            if(email !== undefined && email !== null && email !== '' && email.includes('@') && (email.split('@').length-1 == 1)){
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                valid = re.test(String(email).toLowerCase());
            }
        }
        return valid
    }

    isPhoneValid(phone){
        let phoneValid = false
        let phoneLength = 0
        phone = phone.replace(/[^0-9]/g, "");
        phoneLength = phone.length
        if(phoneLength >= 10){
            phoneValid = true
        }
        return phoneValid
    }

    userHasAccessToPage(user, permissions, page){
        let permissionId = 0
        if(user !== undefined){
            permissionId = user.permissionId
        }
        let availablePages = []
        let unavailablePages = []
        for(let key in permissions){
            let permission = permissions[key]
            if(permission.id === permissionId){
                availablePages = permission.availablePages
                unavailablePages = permission.unavailablePages
                break
            }
        }

        if(user !== undefined && user.unavailablePages !== undefined){
            if(unavailablePages === undefined){
                unavailablePages = []
            }
            for(let userKey in user.unavailablePages){
                let userUnavailablePage = user.unavailablePages[userKey]
                if(!unavailablePages.includes(userUnavailablePage)){
                    unavailablePages.push(userUnavailablePage)
                }
            }
        }

        if(permissionId === 4){
            if(unavailablePages === undefined){
                return true
            }else if(unavailablePages !== undefined && !unavailablePages.includes(page)){
                return true
            }else{
                return false
            }
        }else{
            if(availablePages !== undefined && availablePages.includes(page)){
                return true
            }else if(unavailablePages !== undefined && !unavailablePages.includes(page)){
                return true
            }else{
                return false
            }
        }
    }

    toCurrency(number) {
        if(number === null || number ===undefined || number === NaN){
            return 0
        }
        return number.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('$','');
    }


    validatePercent(percent, allowNegative) {
        if (percent !== undefined) {
            if(allowNegative !== undefined && allowNegative){
                percent = percent.replace(/[^0-9/./-]/g, "");
            }else{
                percent = percent.replace(/[^0-9/.]/g, "");
            }
            while (percent.charAt(0) === '0') {
                percent = percent.substr(1);
            }
            let decimalCount = percent.split(".").length - 1
            if (decimalCount === 1) {
                // get the index of the decimal
                let decimalIndex = percent.indexOf('.');
                let val = percent.length - 1 - decimalIndex
                if (val <= 2) {
                    return percent
                } else {
                    return Number(percent);
                }
            } else if (percent !== '' && decimalCount === 0) {
                return percent
            } else {
                return 0
            }
        } else {
            return 0
        }
    }

    validateAmount(amount, allowNegative) {
        if (amount !== undefined) {
            if(allowNegative !== undefined && allowNegative){
                amount = amount.replace(/[^0-9/./-]/g, "");
            }else{
                amount = amount.replace(/[^0-9/.]/g, "");
            }
            while (amount.charAt(0) === '0') {
                amount = amount.substr(1);
            }
            let decimalCount = amount.split(".").length - 1
            if (decimalCount === 1) {
                // get the index of the decimal
                let decimalIndex = amount.indexOf('.');
                let val = amount.length - 1 - decimalIndex
                if (val <= 2) {
                    return amount
                } else {
                    amount = amount.slice(0, (amount.indexOf(".")) + 3); //With 3 exposing the hundredths place
                    return Number(amount);
                }
            } else if (amount !== '' && decimalCount === 0) {
                return amount
            } else {
                return 0
            }
        } else {
            return 0
        }
    }

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    isAppEmbedded() {
        let params = this.getQueryParams();
        return params.embed;
    }

    getQueryParams() {
        try {
          var query = window.location.search.substring(1);
          let pairs = {}
          var vars = query.split('&');
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            pairs[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
          }
          return pairs
        } catch (e) {
          return {}
        }
      }

    getUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    convertMapToArray(map) {
        let arr = [];
        for (let key in map) {
            arr.push(map[key]);
        }
        return arr;
    }

    convertArrayToMap(arr){
        let m = {}
        for (let key in arr) {
            let v = arr[key]
            m[v.id] = v
        }
        return m;
    }

    getRemainingTrialDays(company) {
        let expirationDate = moment(company.trialExpiresOn)
        let days = expirationDate.diff(moment(), 'days')
        return days + 1
    }

    resizeImage(settings) {
        var file = settings.file;
        var name = settings.file.name
        var maxSize = settings.maxSize;
        var reader = new FileReader();
        var image = new Image();
        var canvas = document.createElement('canvas');

        var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
                atob(dataURI.split(',')[1]) :
                unescape(dataURI.split(',')[1]);
            var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++)
                ia[i] = bytes.charCodeAt(i);
            let blob =   new Blob([ia], { type: mime})
            blob.name = name
            return blob
        };

        var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
                if (width > maxSize) {
                    height *= maxSize / width;
                    width = maxSize;
                }
            } else {
                if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL(file.type ? file.type : `image/${settings.imageType ? settings.imageType : 'jpeg'}`);
            return dataURItoBlob(dataUrl);
        };
        return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
                no(new Error("Not an image"));
                return;
            }
            reader.onload = function (readerEvent) {
                image.onload = function () { return ok(resize()); };
                image.src = readerEvent.target.result;
            };
            return reader.readAsDataURL(file);
        });
    };

}

export default new CommonFunctionsUtils()
